<template>
  <div class="container get-quote">
    <form-wizard @on-change="scrollToTop"
                 shape="square"
                 ref="quote"
                 color="#3498db">
        <h1 slot="title" class="amcredit-font minimal-title text-center text-12-16 f-w-600 color-grey-5 uppercase ls-1">American Credit Loan Application</h1>
        <tab-content title="First step">
          <div class="row">
            <div class="columns col-md-5 offset-md-1">
              <div class="signup-login-wrapper">
                <div class="register-form">
                  <h3>Tell us a bit about your financial situation.</h3>
                  <vue-form-generator 
                    :model="signupData" 
                    :schema="financialFormSchema"
                    :options="formOptions"
                    ref="financialForm">                        
                  </vue-form-generator>
                </div>
                <div class="login-form" style="display: none;">
                </div>
              </div>
              <div class="plan-financial-situation-step-2"><div class="m-b-28"><div class="credit-score-wrapper"><div class="credit-score-title m-b-10">What’s your estimated credit rating?</div> <div class="flex-container credit-score-item-wrapper flex-wrap align-justify">
                <div tabindex="0" data-score="excellent" class="credit-score-item bg-grey-1 flex-child-auto" @click="activate(1)" :class="{ active : active_el == 1 }"><div class="title f-w-600 color-green"><strong>Excellent</strong></div> <div class="intro f-w-500">Score 740 <br>&amp; above</div></div> 
                <div tabindex="0" data-score="great" class="credit-score-item bg-grey-1 flex-child-auto" @click="activate(2)" :class="{ active : active_el == 2 }"><div class="title f-w-600 color-green"><strong>Great</strong></div> <div class="intro f-w-500">Score <br>700 - 739</div></div> 
                <div tabindex="0" data-score="good" class="credit-score-item bg-grey-1 flex-child-auto" @click="activate(3)" :class="{ active : active_el == 3 }"><div class="title f-w-600 color-green"><strong>Good</strong></div> <div class="intro f-w-500">Score <br>660 - 699</div></div> 
                <div tabindex="0" data-score="fair" class="credit-score-item bg-grey-1 flex-child-auto" @click="activate(4)" :class="{ active : active_el == 4 }"><div class="title f-w-600 color-green"><strong>Fair</strong></div> <div class="intro f-w-500">Score <br>620 - 659</div></div></div></div></div>
                <div><div class="quote-section-disclaimer m-b-40 text-12-16 color-grey-4 f-w-500"><p>By providing your mobile number, you agree to receive communications from American Credit by call or text. Standard data and messaging rates may apply.</p></div> <div class="text-center"><button id="pageOneSubmit" class="button" @click="seeYourQuote()" :disabled="!goodToGetQuote">See your quote</button></div></div></div>
            </div>
            <div class="col-md-4 offset-md-1">
              <div class="faq-sticky full-height">
                <div class="faq-widget-wrapper bg-grey-5 border-radius-8 inset">
                  <div class="row">
                    <div class="columns small-12">
                      <h5 class="color-white m-b-16">Common Questions</h5>
                      <ul data-accordion="0d656z-accordion" data-multi-expand="true" data-allow-all-closed="true" class="accordion" role="tablist">
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_1 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="cslxjv-accordion" role="tab" id="cslxjv-accordion-label" aria-expanded="false" aria-selected="false" @click="active_question_1 = !active_question_1"><h6 class="title f-w-400 m-b-0">Do you pull credit?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="cslxjv-accordion-label" :style="`display: ${active_question_1 ? 'block' : 'none' }`" id="cslxjv-accordion">
                            <div class="intro text-16-24"><p>We only do a soft pull. It won’t affect your credit score.</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_2 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="cslxjv-accordion" role="tab" id="cslxjv-accordion-label" aria-expanded="false" aria-selected="false" @click="active_question_2 = !active_question_2"><h6 class="title f-w-400 m-b-0">What can I finance?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="cslxjv-accordion-label" :style="`display: ${active_question_2 ? 'block' : 'none' }`" id="cslxjv-accordion">
                            <div class="intro text-16-24"><p>Any equipment essential to your business.</p></div>
                          </div>
                        </li> 
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_3 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="pnle7o-accordion" role="tab" id="pnle7o-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_3 = !active_question_3"><h6 class="title f-w-400 m-b-0">Are there application fees?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="pnle7o-accordion-label" :style="`display: ${active_question_3 ? 'block' : 'none' }`" id="pnle7o-accordion">
                            <div class="intro text-16-24"><p>No</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_4 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="hxn3zu-accordion" role="tab" id="hxn3zu-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_4 = !active_question_4"><h6 class="title f-w-400 m-b-0">What factors are used to determine credit worthiness?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="hxn3zu-accordion-label" :style="`display: ${active_question_4 ? 'block' : 'none' }`" id="hxn3zu-accordion">
                            <div class="intro text-16-24"><p>Time in business, bank statements, revenue and cash flow conditions, business and credit bureau ratings, and collateral re-marketability are used in the decision-making process.</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_5 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="nyqaqw-accordion" role="tab" id="nyqaqw-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_5 = !active_question_5"><h6 class="title f-w-400 m-b-0">What terms are available?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="nyqaqw-accordion-label" :style="`display: ${active_question_5 ? 'block' : 'none' }`" id="nyqaqw-accordion">
                            <div class="intro text-16-24"><p>24-84 month terms, other options may be available</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_6 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="3vufyv-accordion" role="tab" id="3vufyv-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_6 = !active_question_6"><h6 class="title f-w-400 m-b-0">Can I include soft costs and services?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="3vufyv-accordion-label" :style="`display: ${active_question_6 ? 'block' : 'none' }`" id="3vufyv-accordion">
                            <div class="intro text-16-24"><p>Yes.</p></div>
                          </div>
                        </li>
                      </ul>
                      <!-- <a href="/faqs" class="button button-thin hollow border-grey-4 m-t-40">More Questions</a> -->
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Second step">
          <div class="row">
            <div class="columns col-md-6 offset-md-1 color-grey-5">
              <h3 class="title montserrat f-w-600">Here's your quote for ${{amountToCurrency}}!</h3> 
              <div class="financing-options-wrapper">
                <h5 class="m-b-40 color-grey-4">Select a term option below to apply.</h5>
                <div class="terms-cards-wrapper m-b-30">
                  <div class="terms-cards-items app-card-wrapper" @click="selectTerm(0)">
                    <div tabindex="0" class="terms-card m-b-5 flex-container align-justify" :class="{ active : signupData.loanTerm == 2 }">
                      <div class="flex-child-auto term-value f-w-600">$ {{quoteValue[0]}} <span class="month">/ MONTH</span></div>
                      <div class="term-year flex-child-auto uppercase title f-w-600 text-right">
                        <div>2 <span>years</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="terms-cards-items app-card-wrapper" @click="selectTerm(1)">
                    <div tabindex="0" class="terms-card m-b-5 flex-container align-justify" :class="{ active : signupData.loanTerm == 3 }">
                      <div class="flex-child-auto term-value f-w-600">$ {{quoteValue[1]}} <span class="month">/ MONTH</span></div>
                      <div class="term-year flex-child-auto uppercase title f-w-600 text-right">
                        <div>3 <span>years</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="terms-cards-items app-card-wrapper" @click="selectTerm(2)">
                    <div tabindex="0" class="terms-card m-b-5 flex-container align-justify" :class="{ active : signupData.loanTerm == 4 }">
                      <div class="flex-child-auto term-value f-w-600">$ {{quoteValue[2]}} <span class="month">/ MONTH</span></div>
                      <div class="term-year flex-child-auto uppercase title f-w-600 text-right">
                        <div>4 <span>years</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="terms-cards-items app-card-wrapper" @click="selectTerm(3)">
                    <div tabindex="0" class="terms-card m-b-5 flex-container align-justify" :class="{ active : signupData.loanTerm == 5 }">
                      <div class="flex-child-auto term-value f-w-600">$ {{quoteValue[3]}} <span class="month">/ MONTH</span></div>
                      <div class="term-year flex-child-auto uppercase title f-w-600 text-right">
                        <div>5 <span>years</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="terms-cards-items app-card-wrapper" @click="selectTerm(4)">
                    <div tabindex="0" class="terms-card m-b-5 flex-container align-justify" :class="{ active : signupData.loanTerm == 6 }">
                      <div class="flex-child-auto term-value f-w-600">$ {{quoteValue[4]}} <span class="month">/ MONTH</span></div>
                      <div class="term-year flex-child-auto uppercase title f-w-600 text-right">
                        <div>6 <span>years</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="terms-cards-items app-card-wrapper" @click="selectTerm(5)">
                    <div tabindex="0" class="terms-card m-b-5 flex-container align-justify" :class="{ active : signupData.loanTerm == 7 }">
                      <div class="flex-child-auto term-value f-w-600">$ {{quoteValue[5]}} <span class="month">/ MONTH</span></div>
                      <div class="term-year flex-child-auto uppercase title f-w-600 text-right">
                        <div>7 <span>years</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="apply-form-error" class="apply-form-error is-invalid-label m-b-20"></div>
                <div class="flex-container adjust-spacer">
                  <div class="half-spacer">
                    <button id="emailQuoteButton" class="button hollow" :disabled="!isQuoteSelected" @click="show_email_quote_form = true">Email Quote</button> 
                    <div data-open="email-quote-modal" class="hidden" aria-controls="email-quote-modal" aria-haspopup="true" tabindex="0">Email Quote Trigger</div>
                    <div id="quote-email-sent" class="help-text hide">✓ Email Sent</div>
                  </div>
                  <div class="half-spacer flex-child-auto"><button id="apply-quote" class="button apply-now-button" :disabled="!isQuoteSelected" @click="applyNow()">Apply Now</button></div>
                </div>
              </div> 
              <div class="m-b-20"><a href="javascript:void(0);" class="f-w-500 text-12-16 underline" @click="startOver()">Start Over</a></div>
            </div>
            <div class="col-md-4 offset-md-1">
              <div class="faq-sticky full-height">
                <div class="faq-widget-wrapper bg-grey-5 border-radius-8 inset">
                  <div class="row">
                    <div class="columns small-12">
                      <h5 class="color-white m-b-16">Common Questions</h5>
                      <ul data-accordion="0d656z-accordion" data-multi-expand="true" data-allow-all-closed="true" class="accordion" role="tablist">
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_1 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="cslxjv-accordion" role="tab" id="cslxjv-accordion-label" aria-expanded="false" aria-selected="false" @click="active_question_1 = !active_question_1"><h6 class="title f-w-400 m-b-0">Do you pull credit?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="cslxjv-accordion-label" :style="`display: ${active_question_1 ? 'block' : 'none' }`" id="cslxjv-accordion">
                            <div class="intro text-16-24"><p>We only do a soft pull. It won’t affect your credit score.</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_2 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="cslxjv-accordion" role="tab" id="cslxjv-accordion-label" aria-expanded="false" aria-selected="false" @click="active_question_2 = !active_question_2"><h6 class="title f-w-400 m-b-0">What can I finance?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="cslxjv-accordion-label" :style="`display: ${active_question_2 ? 'block' : 'none' }`" id="cslxjv-accordion">
                            <div class="intro text-16-24"><p>Any equipment essential to your business.</p></div>
                          </div>
                        </li> 
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_3 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="pnle7o-accordion" role="tab" id="pnle7o-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_3 = !active_question_3"><h6 class="title f-w-400 m-b-0">Are there application fees?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="pnle7o-accordion-label" :style="`display: ${active_question_3 ? 'block' : 'none' }`" id="pnle7o-accordion">
                            <div class="intro text-16-24"><p>No</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_4 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="hxn3zu-accordion" role="tab" id="hxn3zu-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_4 = !active_question_4"><h6 class="title f-w-400 m-b-0">What factors are used to determine credit worthiness?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="hxn3zu-accordion-label" :style="`display: ${active_question_4 ? 'block' : 'none' }`" id="hxn3zu-accordion">
                            <div class="intro text-16-24"><p>Time in business, bank statements, revenue and cash flow conditions, business and credit bureau ratings, and collateral re-marketability are used in the decision-making process.</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_5 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="nyqaqw-accordion" role="tab" id="nyqaqw-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_5 = !active_question_5"><h6 class="title f-w-400 m-b-0">What terms are available?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="nyqaqw-accordion-label" :style="`display: ${active_question_5 ? 'block' : 'none' }`" id="nyqaqw-accordion">
                            <div class="intro text-16-24"><p>24-84 month terms, other options may be available</p></div>
                          </div>
                        </li>
                        <li data-accordion-item="" class="accordion-item" role="presentation" :class="{ 'is-active' : active_question_6 }">
                          <a href="javascript:void(0);" class="accordion-title" aria-controls="3vufyv-accordion" role="tab" id="3vufyv-accordion-label" aria-expanded="false" aria-selected="false"  @click="active_question_6 = !active_question_6"><h6 class="title f-w-400 m-b-0">Can I include soft costs and services?</h6></a>
                          <div data-tab-content="" class="accordion-content" role="tabpanel" aria-labelledby="3vufyv-accordion-label" :style="`display: ${active_question_6 ? 'block' : 'none' }`" id="3vufyv-accordion">
                            <div class="intro text-16-24"><p>Yes.</p></div>
                          </div>
                        </li>
                      </ul>
                      <!-- <a href="/faqs" class="button button-thin hollow border-grey-4 m-t-40">More Questions</a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content> 
        <tab-content title="Third step">
          <div class="row">
            <div class="columns col-md-5 offset-md-1">
              <h3 class="montserrat f-w-600 m-b-0 color-gray-5">We're excited to work with you! </h3> <h5 class="color-green montserrat f-w-600 m-b-25">Let’s get started on your application. </h5> <div class="intro m-b-20"><h6 class="montserrat f-w-600 color-grey-4 m-b-20">Here’s what you can expect:</h6> <ul class="no-bullet f-w-400 color-grey-4"><li class="p-b-5 montserrat">This application takes about 3-5 minutes to complete</li> <li class="p-b-5 montserrat">Share your business information so we can do a credit check</li> <li class="p-b-5 montserrat">Our credit check is a soft pull which means it won’t affect your credit rating</li> <li class="p-b-5 montserrat">Upon completion, an American Credit representative will contact you with available options</li></ul></div> <button data-user-state="" class="button button-stretch-medium" @click="goToFinalTab()">Continue</button>
            </div>
            <div class="col-md-4 offset-md-1">
              <div class="plan-card"><div class="card-title text-center uppercase  ls-1 show-for-large">My Plan</div> 
              <!-- <div class="hide-for-large pos-rel"><a href="javascript:void(0)" id="toggle-plan-card" class="toggle-plan-card"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2"></path></svg></a> <div class="flex-container align-middle align-justify"><div><div class="card-title text-center uppercase ls-1">My Plan</div> <div class="plan-item plan-item--amount" style=""><div>Finance Amount</div></div></div> <div class="f-w-600 item-value plan-item--amount--value" style=""><span class="dollar-sign">$</span>123,123</div></div></div>  -->
              <div id="card-content" class="card-content"><div class="m-b-30"><div class="plan-item plan-item--amount flex-container align-middle align-justify show-for-large" style=""><div>Finance Amount</div> <div class="f-w-600 item-value"><span class="dollar-sign">$</span>{{amountToCurrency}}</div></div> <div class="plan-item plan-item--term flex-container align-middle align-justify" style=""><div>Loan Term</div> <div class="f-w-600 item-value"><span>{{signupData.loanTerm}}</span> years</div></div> <div class="plan-item plan-item--monthly-payment flex-container align-middle align-justify" style=""><div>Monthly Payment</div> <div class="f-w-600 item-value">$ {{signupData.monthPayment}} /mo</div></div> <div class="plan-item plan-item--equipment flex-container align-middle align-justify" style="" v-if="signupData.equipmentDescription"><div>Equipment Description</div> <div class="f-w-600 item-value">{{signupData.equipmentDescription}}</div></div> <div class="plan-item plan-item--down-payment flex-container align-middle align-justify" style="display: none;"><div>Down Payment</div> <div class="f-w-600 item-value"></div></div></div> <div class="disclaimer"><p>By providing your mobile number, you agree to receive communications from American Credit by call or text. Standard data and messaging rates may apply.</p></div></div></div>
            </div>
          </div>
        </tab-content> 
        <tab-content title="Last step" icon="ti-check">
          <div class="row">
            <div class="columns col-md-6 offset-md-1">
              <div class="signup-login-wrapper">
                <div class="register-form">
                  <h3>Let's get started</h3>
                  <div class="intro m-b-20 f-w-400 color-gray-4">Enter your email address and set a password so you can save your progress, check application status, and secure the information you share with us.</div>
                  <vue-form-generator 
                    :model="signupData" 
                    :schema="signupFormSchema"
                    :options="formOptions"
                    ref="signupForm">                        
                  </vue-form-generator>
                  <div>
                    <vue-recaptcha
                      ref="invisibleRecaptcha"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                      size="invisible"
                      sitekey="6LcGUl8hAAAAAGmQKbqZHfBWQ5B7uWBRnd-mSWf4">
                    </vue-recaptcha>
                    <button :disabled='!isValidate' @click="recaptchaRegister()" class="signup-button full-width">Continue</button>
                  </div>
                  <div class="text-center"><a href="/login">Sign in to my account</a></div>
                </div>
                <div class="login-form" style="display: none;">
                </div>
              </div>
            </div>
            <div class="col-md-5 right-panel"></div>
          </div>
        </tab-content>
    </form-wizard>
    <div class="reveal-overlay" :style="`display: ${show_email_quote_form ? 'block' : 'none'}`">
      <div id="email-quote-modal" data-reveal="rzho8u-reveal" data-close-on-click="false" class="reveal h-auto mh-auto" role="dialog" aria-hidden="false" data-yeti-box="email-quote-modal" data-resize="email-quote-modal" tabindex="-1" style="display: block; top: 22px;"><button data-close="" aria-label="Close modal" type="button" class="close-button" @click="show_email_quote_form = false"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg></button> 
        <div class="control-section" v-if="!sent_quote_email">
          <h4 class="m-b-40 color-gray-5">Who should we sent the quote to?</h4> 
          <div class="flex-container adjust-spacer flex-container--sm-full">
            <div class="form-item half-spacer placeholder-animate">
              <div><input type="text" id="first-name" name="firstName" placeholder="First Name" autocomplete="off" class="required" v-model="signupData.firstName"> <span class="placeholder">First Name</span></div>
            </div> 
            <div class="form-item half-spacer placeholder-animate">
              <div><input type="text" id="last-name" name="lastName" placeholder="Last Name" autocomplete="off" class="required" v-model="signupData.lastName"> <span class="placeholder">Last Name</span></div>
            </div>
          </div>
          <div class="flex-container adjust-spacer flex-container--sm-full">
            <div class="form-item half-spacer placeholder-animate">
              <div><input type="email" id="email-address" name="emailAddress" placeholder="Email Address" autocomplete="off" class="required" v-model="signupData.quoteEmail" @blur="validateEmail"> <span class="placeholder">Email Address</span></div>
            </div>
          </div> 
          <div class="flex-container adjust-spacer flex-container--sm-full">
            <div class="form-item half-spacer placeholder-animate">
              <div><input type="tel" id="mobile-phone" name="mobilePhone" placeholder="Mobile Phone" autocomplete="off" autocorrect="off" spellcheck="false" data-selector="mobilePhone" class="required mobile-phone" inputmode="text" v-model="signupData.phone" @input="acceptNumber" @blur="validatePhone"> <span class="placeholder">Mobile Phone</span></div>
            </div> 
          </div>
          <div class="quote-section-disclaimer m-b-32 text-12-16 color-grey-4 f-w-500"><p>By providing your mobile number, you agree to receive communications from American Credit by call or text. Standard data and messaging rates may apply.</p></div> 
          <div id="quote-form-error" class="quote-form-error is-invalid-label m-b-20">{{this.msg.email}} {{this.msg.phone}}</div> 
          <div class="flex-container adjust-spacer">
            <div class="half-spacer"><button data-close="" class="button button-thin hollow" @click="show_email_quote_form = false">Cancel</button></div> 
            <div class="half-spacer"><button class="button button-thin send-quote-email" :disabled="!validateEmailQuoteForm()" @click="emailQuote()">Email Quote</button></div>
          </div>
        </div> 
        <div v-if="sent_quote_email">
          <div class="flex-container align-middle flex-container--sm-full"><div class="p-l-16 p-r-25 sp-r-0 m-b-20"><svg width="75" height="62" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="62" height="62" rx="31" fill="#FCE460"></rect><path d="M26.5 22.922a2.5 2.5 0 0 1 .938-1.952l21-16.8a2.5 2.5 0 0 1 3.124 0l21 16.8a2.5 2.5 0 0 1 .938 1.953V51a2.5 2.5 0 0 1-2.5 2.5H29a2.5 2.5 0 0 1-2.5-2.5V22.922Z" stroke="#1E4646" stroke-width="3"></path><path d="M28 8h43v14L49.011 36 28 22V8Z" fill="#91C855"></path><path d="M71.875 21.5 49.188 36.64M42 22l6.94 5.136L59 15M26.5 21.5l45.374 30.28" stroke="#1E4646" stroke-width="3"></path></svg></div> 
            <div class="p-l-25 sp-l-0 m-b-10"><h4 class="m-b-18">Email Sent!</h4> 
              <div class="m-b-40 color-grey-4">Thanks — we’ve sent this quote to {{signupData.quoteEmail}}.</div> 
              <button data-close="" class="button button-thin" @click="show_email_quote_form = false">Ok</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../vuex/types";
import VueFormGenerator from 'vue-form-generator'
import api from "../vuex/api/index";
import Cookie from 'js-cookie';
import { validators } from "vue-form-generator";
import CommonConstants from "../constant/common.js";
import axios from 'axios';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: "GetQuoteAndSignup",
  components: {
    "vue-form-generator": VueFormGenerator.component,
    'vue-recaptcha': VueRecaptcha
  },
  data () {
    return {
      // product: '',
      msg: {
        email: '',
        phone: ''
      },
      quoteStrings: [],
      active_el: 0,
      active_question_1: false,
      active_question_2: false,
      active_question_3: false, 
      active_question_4: false, 
      active_question_5: false, 
      active_question_6: false,
      isCreditSelected: false,
      isQuoteSelected: false,
      creditRatings: ['Excellent', 'Great', 'Good', 'Fair'],
      show_email_quote_form: false,
      sent_quote_email: false,
      signupData:{
        selectedProduct: null,
        firstName: '',
        lastName: '',
        quoteEmail: '',
        phone: '',
        amount: '',
        equipmentDescription: '',
        yearsInBusiness: '',
        creditRating: '',
        loanTerm: '',
        monthPayment: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        promoCode: '',
        ghref: ''
      },
      formOptions: {
        validationErrorClass: "has-error",
        validationSuccessClass: "has-success",
        // validateAfterLoad: true,
        validateAfterChanged: true
      },
      financialFormSchema: {
        fields: [
          {
            type: "input",
            inputType: "number",
            min: 10000,
            max: 999999,
            label: "How much do you want to borrow?",
            model: "amount",
            // placeholder: 'Enter an amount',
            required: true,
            validator: VueFormGenerator.validators.number,
            styleClasses:'col-lg-12 input-type-number'
          },
          {
            type: 'select',
            label: 'What kind of equipment are you financing?',
            model: 'equipmentDescription',
            values: ['Agriculture', 'Air Transportation', 'Automotive', 'Building Automation', 'Commercial', 'Construction', 'Fitness & Spa', 'Food Service', 'Intermodal', 'Landscaping', 'Logging', 'Manufacturing', 'Marine Transportation', 'Material Handling', 'Medical', 'Packaging', 'Printing', 'Rail Transportation', 'Software', 'Technology - A/V', 'Technology - Commercial', 'Technology - Infrastructure', 'Trailer - OTR', 'Trailer - Vocational', 'Truck - OTR', 'Truck - Vocational', 'XX Accessories'],
            required: true,
            validator: "required",
            selectOptions: {
              noneSelectedText: "Equipment Description"
            },
            styleClasses:'col-lg-12',
            onChanged: function(model, newVal, oldVal, field) {
              field.styleClasses = field.styleClasses + ' selected';
            }
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'How many years have you been in business?',
            model: "yearsInBusiness",
            // placeholder: 'Enter a number of years',
            required:true,
            validator: VueFormGenerator.validators.number,
            styleClasses:'col-lg-12 custom-input'
          }
        ]
      },
      signupFormSchema:{
        fields:[
          {
            type: 'select',
            placeholder: 'Which loan would you like to apply for?',
            model: 'selectedProduct',
            values: ['Equipment Finance', 'Working Capital Term Loan', 'AR Factoring', 'Real Estate Loan', '2nd Mortgage Loan'],
            required: true,
            validator: "required",
            selectOptions: {
              noneSelectedText: "Which loan would you like to apply for?"
            },
            styleClasses:'col-lg-12 custom-input select-top-placeholder',
            onChanged: function(model, newVal, oldVal, field) {
              field.styleClasses = field.styleClasses + ' selected';
            }
          },
          {
            type: 'input',
            inputType: "email",
            placeholder: "Email Address",
            model: 'email',
            required: true,
            validator: VueFormGenerator.validators.email,
            hint: 'You\'ll use your email address to sign in.',
            styleClasses:'col-md-12 custom-input m-b-20 input-top-placeholder'
          },
          {
            type: "cleave",
            inputType: "text",
            placeholder: "Phone Number",
            model: "phone",
            required:true,
            min: 13,
            validator: validators.string.locale({
              fieldIsRequired: "This field is required!",
              textTooSmall: "Please input a valid number."
            }),
            cleaveOptions: {
              blocks: [0, 3, 3, 4],
              delimiters: ["(", ")", "-"],
              numericOnly: true
            },
            styleClasses:'col-md-12 custom-input input-top-placeholder'
          },
          {
            type: 'input',
            inputType: "password",
            placeholder: "Password",
            model: 'password',
            min: 8,
            required: true,
            validator: validators.string.locale({
              fieldIsRequired: "This field is required!",
              textTooSmall: "Password must be at least {1} characters"
            }),
            styleClasses:'col-md-12 custom-input input-top-placeholder'
          },{
            type: 'input',
            inputType: "password",
            placeholder: "Confirm Password",
            model: 'confirmPassword',
            // min: 8,
            required: true,
            styleClasses:'col-md-12 custom-input m-b-40 input-top-placeholder',
            validator: [VueFormGenerator.validators.string,
              (value, field, model) => {
                  let pass = model.password;
                  let confPass = value;
                  if (pass != confPass) {
                    return [" Passwords don't match."];
                  } else {
                    return [];
                  }
                }
            ]
        },
          // {
          //   type: 'input',
          //   inputType: "text",
          //   placeholder: "Promotion Code",
          //   model: 'promoCode',
          //   validator: [VueFormGenerator.validators.string,
          //     (value, field, model) => {
          //         let promo = value.toLowerCase();
          //         if (promo != 'amcredit') {
          //           return ["Invalid promotion code."];
          //         } else {
          //           return [];
          //         }
          //       }
          //   ],
          //   max: 50,
          //   styleClasses:'col-md-12 custom-input input-top-placeholder'
          // },
        ]
      },
    }
  },
  computed: {
    // step() {
    //   return this.$route.query.step;
    // },
    pageTitle() {
      if(this.$route.query.product && this.$route.query.product == 'term-loan') {
        // this.product = 'term-loan';
        return 'Term Loan Application'
      }
      if(this.$route.query.step && this.$route.query.step < 4) {
        return 'Equipment Financing Quote'
      } else {
        return 'Equipment Financing Application'
      }
    },
    goodToGetQuote() {
      return this.isCreditSelected && this.$refs.financialForm.validate();
    },
    isValidate() {
      return this.signupData.selectedProduct && this.signupData.email && this.signupData.password && this.signupData.confirmPassword && (this.signupData.password === this.signupData.confirmPassword) && this.signupData.promoCode.length < 51;
    },
    quoteValue() {
      var quoteStrings = [];
      if(this.signupData.amount && this.signupData.amount > 9999 && this.signupData.creditRating && this.signupData.creditRating !== '') {
        var values = CommonConstants.quoteTable[this.signupData.creditRating];
        for(var i=0; i<values.length-1; i=i+2) {
          var startValue = (values[i] * this.signupData.amount/1000).toFixed(0);
          var endValue = (values[i+1] * this.signupData.amount/1000).toFixed(0);
          var valueString = Number(startValue).toLocaleString() + ' - ' + Number(endValue).toLocaleString();
          quoteStrings.push(valueString);
        }
      }
      this.quoteStrings = quoteStrings;
      return quoteStrings;
    },
    amountToCurrency() {
      return Number(this.signupData.amount).toLocaleString();
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: types.SET_USER
    }),
    ...mapActions({
      setAlertMessage: types.SET_FAIL_MESSAGE
    }),
    validateRegisterTab: function(){
      return this.$refs.signupForm.validate();
    },
    emailQuote: function() {
      var _this = this;
      
      // POST request using axios with set headers
      var quoteApplyLink = 'https://portal.amcredit.com/get-start?step=3&amount=' + this.signupData.amount + '&creditRating=' + this.signupData.creditRating + '&email=' + this.signupData.quoteEmail 
      + '&term=' + this.signupData.loanTerm + '&monthlyPayment=' + this.signupData.monthPayment + '&equipment=' + this.signupData.equipmentDescription + '&yearsInBusiness=' + this.signupData.yearsInBusiness;

      var data = {
        customerEmail: _this.signupData.quoteEmail, 
        applicationLink: quoteApplyLink,
        dealAmount: _this.signupData.amount, 
        dealLoanTerm: _this.signupData.loanTerm + ' years', 
        quoteMonthlyPayment: _this.signupData.monthPayment, 
        creditRating: _this.signupData.creditRating, 
        equipmentDescription: _this.signupData.equipmentDescription, 
        yearsInBusiness: _this.signupData.yearsInBusiness, 
        firstName: _this.signupData.firstName, 
        lastName: _this.signupData.lastName, 
        phone: _this.signupData.phone
      }

      axios.post("https://api.amcredit.com/apply/sendQuoteEmail", data)
      .then(res => {
        console.log(res)
        this.sent_quote_email = true;
      })
      .catch(err => console.log(err.message));

      // hubspot create new contact
      var dataProperties = [
        { property: 'website_email_quote_tag', value: 'Website new quote email requested' },
        { property: 'applied_product', value: 'Equipment Finance' },
        { property: 'deal_amount', value: _this.signupData.amount },
        { property: 'firstname', value: _this.signupData.firstName },
        { property: 'lastname', value: _this.signupData.lastName },
        { property: 'phone', value: _this.signupData.phone },
        { property: 'deal_loan_term', value: _this.signupData.loanTerm + ' years' },
        { property: 'quote_apply_link', value: quoteApplyLink },
        { property: 'quote_monthly_payment', value: '$ ' + _this.signupData.monthPayment },
        { property: 'years_in_business', value: _this.signupData.yearsInBusiness },
        { property: 'equipment_description', value: _this.signupData.equipmentDescription },
        { property: 'credit_rating', value: _this.signupData.creditRating }
      ];

      console.log(dataProperties)

      const body = {
        email: _this.signupData.quoteEmail,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => {
          console.log(response)
          this.sent_quote_email = true;
        })
        .catch(error => console.log(error.message))
    },
    validateEmailQuoteForm: function() {
      return this.signupData.quoteEmail && this.signupData.firstName && this.signupData.lastName && this.signupData.phone && !this.msg.email && !this.msg.phone;
    },
    startOver: function() {
      this.$refs.quote.changeTab(1, 0);
      this.$router.replace({query: {...this.$route.query, step: 1}})
    },
    scrollToTop: function() {
      window.scrollTo(0,0);
    },
    activate: function(el) {
      if(this.$refs.financialForm.validate()) {
        this.active_el = el;
        this.signupData.creditRating = this.creditRatings[el - 1];
        this.isCreditSelected = true;
      }
    },
    selectTerm: function(index) {
      this.isQuoteSelected = true;
      this.signupData.loanTerm = index + 2;
      this.signupData.monthPayment = this.quoteStrings[index];
    },
    seeYourQuote: function() {
      this.$refs.quote.changeTab(0, 1);
      this.$router.replace({query: {...this.$route.query, step: 2}})
    },
    applyNow: function() {
      this.$refs.quote.changeTab(1, 2);
      this.$router.replace({query: {...this.$route.query, step: 3}})
    },
    goToFinalTab: function() {
      this.$refs.quote.changeTab(2, 3);
      this.$router.replace({query: {...this.$route.query, step: 4}})
    },
    recaptchaRegister() {
      console.log('1')
      this.$refs.invisibleRecaptcha.execute();
      console.log('2')

    },
    onCaptchaVerified(recaptchaToken) {
      console.log('3')
      this.brokerRegisterUser(recaptchaToken);
    },
    onCaptchaExpired() {
      console.log('4')
      this.$refs.invisibleRecaptcha.reset();
    },
    brokerRegisterUser() {
      var _this = this;

      // var referralData = {
      //   partnerId: this.signupData.ghref.split(':')[1],
      //   orderNumber: '12345',
      //   firstName: 'test',
      //   lastName: 'abc',
      //   email: 'testemail@123.com',
      //   customerId: 'abcdefg',
      //   commission: '500',
      //   loanAmount: '180000'
      // }

      // // new application slack notification
      // axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
      //         .post('https://hooks.zapier.com/hooks/catch/11204908/2ry7kbf/', referralData);

      // return

      // var sendData = {
      //   email: _this.signupData.email, 
      //   message: 'Customer started new ' + _this.signupData.selectedProduct.toLowerCase() + ' application!'
      // }

      // new application slack notification
      // axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
      //       .post('https://hooks.zapier.com/hooks/catch/11204908/bpsg1lq/', sendData);
              
      var registerData = {
          firstName: '',
          lastName: '',
          middleName: '',
          email: _this.signupData.email,
          phone: _this.signupData.phone,
          customerLoginPwd: _this.signupData.confirmPassword,
          promoCode: _this.signupData.promoCode
      };
          
      api.brokerRegisterUser(registerData)
      .then(res => {
        if (Number(res.data.code) == 0) {
          // hubspot create new contact
          this.createOrUpdateHubspotContact('Website new loan application started');

          var data = res.data.data
          var str = data.crmCustomerLoginName
          if (str.indexOf('+1') >= 0) {
            data.crmCustomerLoginName = str.slice(2)
          }
          Cookie.set('userData', encodeURIComponent(JSON.stringify(data)));
          Cookie.set('customerId', data.crmCustomerId);
          _this.setUserInfo(data);
          if(_this.signupData.selectedProduct == 'Working Capital Term Loan') {
            setTimeout(function() {
              _this.$router.push({
                path: '/apply-term-loan',
                query: {
                  ghref: _this.signupData.ghref
                }
              });
              window.location.reload(true);
            }, 10);
          }
          if(_this.signupData.selectedProduct == 'Real Estate Loan') {
            setTimeout(function() {
              _this.$router.push({
                path: '/apply-real-estate',
                query: {
                  ghref: _this.signupData.ghref
                }
              });
              window.location.reload(true);
            }, 10);
          } 
          if(_this.signupData.selectedProduct == '2nd Mortgage Loan') {
            setTimeout(function() {
              _this.$router.push({
                path: '/apply-2nd-mortgage',
                query: {
                  ghref: _this.signupData.ghref
                }
              });
              window.location.reload(true);
            }, 10);
          } 
          if(_this.signupData.selectedProduct == 'AR Factoring') {
            setTimeout(function() {
              _this.$router.push({
                path: '/apply-AR-factoring',
                query: {
                  ghref: _this.signupData.ghref
                }
              });
              window.location.reload(true);
            }, 10);
          } 
          if(_this.signupData.selectedProduct == 'Equipment Finance') {
            setTimeout(function() {
              _this.$router.push({
                path: '/apply',
                query: {
                  amount: _this.signupData.amount,
                  term: _this.signupData.loanTerm,
                  equipment: _this.signupData.equipmentDescription,
                  yearsInBusiness: _this.signupData.yearsInBusiness,
                  ghref: _this.signupData.ghref
                }
              });
              window.location.reload(true);
            }, 10);
          }
          // _this.$router.push({
          //   path: '/apply',
          //   query: {
          //     email: this.signupData.email
          //   }
          // })
        } else {
          if (res.data.result === 'Registration failed, email has been registered') {
            // hubspot create new contact
            this.createOrUpdateHubspotContact('Website new loan application email has been registered');

            this.setAlertMessage({
              show: true,
              content: 'It seems that this email has been registered. Please log in directly'
            });
            //reset google recaptcha
            this.$refs.invisibleRecaptcha.reset();
            // alert(res.data.result);
          }
        }
      })
    },

    createOrUpdateHubspotContact (apply_tag) {
      var _this = this;
      // hubspot create new contact
      // POST request using axios with set headers

      var dataProperties = [
        { property: 'applied_successfully', value: false },
        { property: 'website_new_apply_tag', value: apply_tag },
        { property: 'applied_product', value: _this.signupData.selectedProduct },
        { property: 'phone', value: _this.signupData.phone },
        { property: 'contact_type', value: 'Direct' }
      ];

      console.log(dataProperties)

      const body = {
        email: _this.signupData.email,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => console.log(response))
        .catch(error => console.log(error.message))
    },
    acceptNumber() {
      var x = this.signupData.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.signupData.phone = !x[2] ? x[1] : '(' + x[1] + ')' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    validatePhone() {
      if(this.signupData.phone.length != 13) {
        this.msg.phone = 'Please enter a valid phone number';
      } else {
        this.msg.phone = '';
      }
    },
    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.signupData.quoteEmail)) {
        this.msg.email = '';
      } else {
        this.msg.email = 'Please enter a valid email address';
      }
    }
    // },
    // insertAfter(referenceNode, newNode) {
    //   referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    // }
  },
  // watch: {
  //   step(newVal,oldVal) {
  //     if(newVal == undefined) {
  //       window.location.reload(true);
  //     }
  //   }
  // },
  mounted() {
    if(this.$route.query.ghref) {
      this.signupData.ghref = this.$route.query.ghref;
    }
    if(this.$route.query.product == 'term-loan') {
      this.signupData.selectedProduct = 'Working Capital Term Loan';
    }
    var step = this.$route.query.step;
    if(step) {
      if(step == 3) {
        if(this.$route.query.amount) {
          this.signupData.amount = this.$route.query.amount;
        }
        if(this.$route.query.email) {
          this.signupData.email = this.$route.query.email;
        }
        if(this.$route.query.term) {
          this.signupData.loanTerm = this.$route.query.term;
        }
        if(this.$route.query.monthlyPayment) {
          this.signupData.monthPayment = this.$route.query.monthlyPayment;
        }
        if(this.$route.query.equipment) {
          this.signupData.equipmentDescription = this.$route.query.equipment;
        }
        if(this.$route.query.yearsInBusiness) {
          this.signupData.yearsInBusiness = this.$route.query.yearsInBusiness;
        }
      }
      //need to refine redirect all to step 1, reset all queries
      this.$refs.quote.changeTab(0, step - 1);
    } else {
      this.$refs.quote.changeTab(0, 3);
    }

    // var inputElements = document.getElementsByClassName("form-control");
    // var el = document.createElement("span");
    // el.innerHTML = "test";
    // for(var i = 0; i < inputElements.length; i++) {
    //   // this.insertAfter(inputElements[i], el);
    //   inputElements[i].parentNode.insertBefore(el, inputElements[i].nextSibling);
    // }
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    if(window.location.pathname == "/") {
      document.title = "American Credit Small Business Loans Application";
      meta.content = "Apply loan with American Credit. Create an account, monitor applications, and safeguard your information.";
      keywords.content = "American Credit, Asset-Based Lending, Small and Medium Enterprises Financing, Equipment Financing, Online Loan Application, Digital Financing, Working Capital Financing";
    } 
    if(window.location.pathname == "/get-start"){
      document.title = "Get Started with American Credit";
      meta.content = "Start with American Credit. Set up an account, track your application, and secure your information.";
      keywords.content = "American Credit, Asset-Based Lending, Small and Medium Enterprises Financing, Equipment Financing, Online Loan Application, Digital Financing, Working Capital Financing";
    }
  }
}
</script>

<style lang="scss" scoped>

.placeholder {
  position: absolute;
  font-size:25px;
  pointer-events: none;
  left: 1px;
  top: 1px;
  transition: 0.1s ease all;
}

input:focus ~ .placeholder{
  top: 1px;
  font-size: 11px;
}

.credit-score-title {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    font-weight: 400;
    margin-bottom: .625rem;
    margin-top: 1rem;
}

@media print, screen and (min-width: 48em) {
  .h3, h3 {
    font-size: 2rem !important;
    line-height: 1.25 !important;
  }
  .h5, h5 {
    font-size: 1.25rem !important;
    line-height: 1.6 !important;
  }
}

strong{font-weight:bolder;}
button{font-size:100%;line-height:1.15;margin:0;}
button{overflow:visible;}
button{text-transform:none;}
button{-webkit-appearance:button;}
button::-moz-focus-inner{border-style:none;padding:0;}
button:-moz-focusring{outline:1px dotted ButtonText;}
*,::after,::before{box-sizing:inherit;}
button{padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border-radius:.25rem;background:0 0;line-height:1;cursor:auto;}
[data-whatinput=mouse] button{outline:0;}
::-webkit-input-placeholder{color:rgba(30,70,70,.5);}
:-ms-input-placeholder{color:rgba(30,70,70,.5);}
::placeholder{color:rgba(30,70,70,.5);}
// div,p{margin:0;padding:0;}
p{margin-bottom:1.5em;font-size:inherit;line-height:1.5;text-rendering:optimizeLegibility;}
strong{font-weight:700;line-height:inherit;}
.text-center{text-align:center;}

.button{display:inline-block;vertical-align:middle;margin:0 0 1rem 0;padding:.85em 1em;border:1px solid transparent;border-radius:.25rem;transition:background-color .25s ease-out,color .25s ease-out;font-size:.75rem;-webkit-appearance:none;line-height:1;text-align:center;cursor:pointer;}
[data-whatinput=mouse] .button{outline:0;}
.button,.button[disabled],.button[disabled]:focus,.button[disabled]:hover{background-color:#5456ff;color:#fff;}
.button:focus,.button:hover{background-color:#5456ff;color:#fff;}
.button[disabled]{opacity:.25;cursor:not-allowed;}
.align-justify{-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}
.flex-container{display:-webkit-flex;display:-ms-flexbox;display:flex;}
.flex-child-auto{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;}
p{letter-spacing:-.00625rem;}
.button{font-size:.75rem;line-height:1rem;padding:.6875rem 1.5rem;border-radius:1.25rem;letter-spacing:1px;text-align:center;font-weight:600;text-transform:uppercase;min-width:9.75rem;}
@media print,screen and (max-width:47.99875em){
.button{min-width:0;}
}
.intro{letter-spacing:-.03125rem;font-weight:600;font-family:Montserrat,sans-serif;}
.color-green{color:#538e37;}
.color-grey-4{color:#787d78;}
.bg-grey-1{background-color:#f0f4f0;}
.f-w-500{font-weight:500;}
.f-w-600{font-weight:600;}
.flex-wrap{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}
.m-b-10{margin-bottom:.625rem;}
.m-b-28{margin-bottom:1.75rem;}
.m-b-40{margin-bottom:2.5rem;}
@media print,screen and (max-width:47.99875em){
.m-b-40{margin-bottom:2rem;}
}
.text-12-16{font-size:.75rem;line-height:1rem;}
.entry-content p{word-break:break-word;}
button:focus{outline:0;}
.credit-score-item-wrapper{margin-left:-.125rem;margin-right:-.125rem;}
@media print,screen and (max-width:47.99875em){
.credit-score-item-wrapper{display:block;white-space:nowrap;position:relative;overflow-x:scroll;overflow-y:hidden;margin-left:-1.5rem;margin-right:-1.5rem;}
}
@media print,screen and (max-width:47.99875em){
.credit-score-item-wrapper::-webkit-scrollbar{width:0;height:0;}
.credit-score-item-wrapper{overflow:-moz-scrollbars-none;-ms-overflow-style:none;}
}
.credit-score-item{padding:1rem 1.5rem;margin-left:.125rem;margin-right:.125rem;background-color:#fff;cursor:pointer;border-radius:.5rem;color:#787d78;}
.credit-score-item.bg-grey-1{background-color:#f0f4f0;}
.credit-score-item.bg-grey-1:hover:not(.active){background-color:#f0f4f0;}
@media print,screen and (max-width:47.99875em){
.credit-score-item{margin-bottom:1.25rem;display:inline-block;zoom:1;}
.credit-score-item:first-child{margin-left:1.5rem;}
.credit-score-item:last-child{margin-right:1.5rem;}
}
.credit-score-item .title{text-transform:capitalize;}
.credit-score-item .intro{font-size:.75rem;line-height:1rem;font-weight:500;}
.credit-score-item:hover{box-shadow:0 4px 24px rgba(0,0,0,.15);background-color:#e3e6e3;position:relative;z-index:1;}
.credit-score-item.active{box-shadow:0 4px 24px rgba(0,0,0,.15);background-color:#fff0a5;border-color:transparent;color:#787d78;}

@media all{
h3,h5{overflow-wrap:break-word;}
}
.montserrat{font-family:Montserrat,sans-serif;}
a{background-color:transparent;}
button,textarea{font-size:100%;line-height:1.15;margin:0;}
button{-webkit-appearance:button;}
button::-moz-focus-inner{border-style:none;padding:0;}
button:-moz-focusring{outline:1px dotted ButtonText;}
textarea{overflow:auto;}
*,::after,::before{box-sizing:inherit;}
textarea{height:auto;min-height:50px;border-radius:.25rem;}
button{padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border-radius:.25rem;background:0 0;line-height:1;cursor:auto;}
[data-whatinput=mouse] button{outline:0;}
.columns{-webkit-flex:1 1 0px;-ms-flex:1 1 0px;flex:1 1 0px;padding-right:.75rem;padding-left:.75rem;min-width:0;}
@media print,screen and (min-width:48em){
.columns{padding-right:.75rem;padding-left:.75rem;}
}
.small-12{-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;}
@media print,screen and (min-width:64em){
.large-offset-1{margin-left:8.33333%;}
.large-6{-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
}
textarea{display:block;box-sizing:border-box;width:100%;height:3.4375rem;margin:0 0 1rem;padding:1rem;border:0;border-radius:.25rem;background-color:#f0f4f0;box-shadow:none;font-size:1rem;font-weight:600;line-height:1.5;color:#1e4646;transition:box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;}
textarea:focus{outline:0;border:0;background-color:#f0f4f0;box-shadow:none;transition:box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;}
textarea{max-width:100%;}
textarea:disabled{background-color:#f0f4f0;cursor:not-allowed;}
::-webkit-input-placeholder{color:rgba(30,70,70,.5);}
:-ms-input-placeholder{color:rgba(30,70,70,.5);}
::placeholder{color:rgba(30,70,70,.5);}
.help-text{margin-top:-.5rem;font-size:.625rem;font-style:normal;color:#787d78;}
.is-invalid-label{color:#d44e4e;}
// div,h3,h5{margin:0;padding:0;}
h3,h5{font-family:"DM Serif Display",serif;font-style:normal;font-weight:400;color:inherit;text-rendering:optimizeLegibility;}
h3{font-size:1.625rem;line-height:1.23077;margin-top:0;margin-bottom:.875rem;}
h5{font-size:1rem;line-height:1.5;margin-top:0;margin-bottom:.875rem;}
@media print,screen and (min-width:48em){
h3{font-size:2rem;line-height:1.25;}
h5{font-size:1.25rem;line-height:1.6;}
}
a{line-height:inherit;color:#3282a0;text-decoration:none;cursor:pointer;}
a:focus,a:hover{color:#2b708a;}
.text-right{text-align:right;}
@media print{
*{background:0 0!important;color:#000!important;color-adjust:economy;box-shadow:none!important;text-shadow:none!important;}
a,a:visited{text-decoration:underline;}
a[href]:after{content:" (" attr(href) ")";}
a[href^='javascript:']:after{content:'';}
h3{orphans:3;widows:3;}
h3{page-break-after:avoid;}
}
.button{display:inline-block;vertical-align:middle;margin:0 0 1rem 0;padding:.85em 1em;border:1px solid transparent;border-radius:.25rem;transition:background-color .25s ease-out,color .25s ease-out;font-size:.75rem;-webkit-appearance:none;line-height:1;text-align:center;cursor:pointer;}
[data-whatinput=mouse] .button{outline:0;}
.button,.button[disabled],.button[disabled]:focus,.button[disabled]:hover{background-color:#91c855;color:#1e4646;}
.button.hollow,.button.hollow:focus,.button.hollow:hover,.button.hollow[disabled],.button.hollow[disabled]:focus,.button.hollow[disabled]:hover{background-color:transparent;}
.button.hollow,.button.hollow[disabled],.button.hollow[disabled]:focus,.button.hollow[disabled]:hover{border:1px solid #91c855;color:#91c855;}
.button.hollow:focus,.button.hollow:hover{border-color:#496c23;color:#496c23;}
.button[disabled]{opacity:.25;cursor:not-allowed;}
.hide{display:none!important;}
.align-justify{-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}
.flex-container{display:-webkit-flex;display:-ms-flexbox;display:flex;}
.flex-child-auto{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;}
h3,h5{font-family:Montserrat,sans-serif;font-weight:600;}
h3{letter-spacing:-.03125rem;}
h5{letter-spacing:-.03125rem;}
.button{font-size:.75rem;line-height:1rem;padding:.6875rem 1.5rem;border-radius:1.25rem;letter-spacing:1px;text-align:center;font-weight:600;text-transform:uppercase;min-width:9.75rem;}
@media print,screen and (max-width:47.99875em){
.button{min-width:0;}
}
.button.hollow{border:1px solid #91c855;color:#1e4646;}
.color-grey-4{color:#787d78;}
.f-w-500{font-weight:500;}
.f-w-600{font-weight:600;}
.underline{text-decoration:underline;}
.uppercase{text-transform:uppercase;}
.hidden{display:none;}
.m-b-5{margin-bottom:.3125rem;}
.m-b-20{margin-bottom:1.25rem;}
.m-b-30{margin-bottom:1.875rem;}
.m-b-40{margin-bottom:2.5rem;}
@media print,screen and (max-width:47.99875em){
.m-b-40{margin-bottom:2rem;}
}
.adjust-spacer{margin-left:-.25rem;margin-right:-.25rem;}
.half-spacer{padding-left:.25rem;padding-right:.25rem;}
.text-12-16{font-size:.75rem;line-height:1rem;}
textarea{padding:1rem;font-size:1rem;line-height:1.5rem;color:#1e4646;width:100%;margin-bottom:.5rem;}
textarea:focus{box-shadow:0 0 0 1px #787d78;}
#application-form textarea::-webkit-input-placeholder{color:transparent;}
#application-form textarea:-moz-placeholder{color:transparent;}
#application-form textarea::-moz-placeholder{color:transparent;}
#application-form textarea:-ms-input-placeholder{color:transparent;}
#application-form textarea:focus{padding:1.625rem 1rem .875rem;}
#application-form textarea:focus::-webkit-input-placeholder{font-size:.75rem;line-height:1rem;}
#application-form textarea:focus:-moz-placeholder{font-size:.75rem;line-height:1rem;}
#application-form textarea:focus::-moz-placeholder{font-size:.75rem;line-height:1rem;}
#application-form textarea:focus:-ms-input-placeholder{font-size:.75rem;line-height:1rem;}
textarea{border:0;resize:vertical;}
#application-form textarea:focus{padding:1rem;}
.help-text{margin-top:-.3125rem;}
.help-text{font-weight:600;}
[data-whatinput=mouse] a:focus,button:focus{outline:0;}
.terms-card{padding:2rem 1.5rem;cursor:pointer;border-radius:.25rem;background-color:#f0f4f0;}
.terms-card:hover{box-shadow:0 0 16px rgba(0,0,0,.16);position:relative;z-index:1;}
.terms-card.active,.terms-card:active,.terms-card:focus{box-shadow:0 4px 24px rgba(0,0,0,.15);background-color:#fff0a5;}
.terms-card.active .term-year div,.terms-card:active .term-year div,.terms-card:focus .term-year div{background-color:#053A7A!important;color:#fff;}
.term-value{font-size:1.25rem;line-height:2rem;letter-spacing:-.03125rem;font-family:Montserrat,sans-serif;}
.term-value span{font-size:.75rem;line-height:1rem;letter-spacing:normal;font-family:Montserrat,sans-serif;}
.term-year{font-weight:600;}
.term-year div{background-color:#fff;color:#1e4646;padding:.25rem 1rem;border-radius:3.75rem;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;font-family:Montserrat,sans-serif;}
.term-year span{padding-left:.3125rem;font-size:.75rem;line-height:1rem;letter-spacing:.0625rem;font-family:Montserrat,sans-serif;}
.apply-now-button{max-width:21.8125rem;width:100%;}

@media all{
h3,h5,h6{overflow-wrap:break-word;}
ul{overflow-wrap:break-word;}
}
.montserrat{font-family:Montserrat,sans-serif;}
button{-webkit-appearance:button;}
button::-moz-focus-inner{border-style:none;padding:0;}
button:-moz-focusring{outline:1px dotted ButtonText;}
*,::after,::before{box-sizing:inherit;}
button{padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border-radius:.25rem;background:0 0;line-height:1;cursor:auto;}
[data-whatinput=mouse] button{outline:0;}
.columns{-webkit-flex:1 1 0px;-ms-flex:1 1 0px;flex:1 1 0px;padding-right:.75rem;padding-left:.75rem;min-width:0;}
@media print,screen and (min-width:48em){
.columns{padding-right:.75rem;padding-left:.75rem;}
}
.small-12{-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;}
@media print,screen and (min-width:64em){
.large-offset-1{margin-left:8.33333%;}
.large-6{-webkit-flex:0 0 50%;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;}
}
::-webkit-input-placeholder{color:rgba(30,70,70,.5);}
:-ms-input-placeholder{color:rgba(30,70,70,.5);}
::placeholder{color:rgba(30,70,70,.5);}
// div,h3,h5,h6,li,ul{margin:0;padding:0;}
h3,h5,h6{font-family:"DM Serif Display",serif;font-style:normal;font-weight:400;color:inherit;text-rendering:optimizeLegibility;}
h3{font-size:1.625rem;line-height:1.23077;margin-top:0;margin-bottom:.875rem;}
h5{font-size:1rem;line-height:1.5;margin-top:0;margin-bottom:.875rem;}
h6{font-size:1rem;line-height:1.5;margin-top:0;margin-bottom:.875rem;}
@media print,screen and (min-width:48em){
h3{font-size:2rem;line-height:1.25;}
h5{font-size:1.25rem;line-height:1.6;}
h6{font-size:1rem;line-height:1.5;}
}
ul{margin-bottom:1.5em;list-style-position:outside;line-height:1.5;}
li{font-size:inherit;}
ul{margin-left:1.25rem;list-style-type:disc;}
ul.no-bullet{margin-left:0;list-style:none;}
@media print{
*{background:0 0!important;color:#000!important;color-adjust:economy;box-shadow:none!important;text-shadow:none!important;}
h3{orphans:3;widows:3;}
h3{page-break-after:avoid;}
}
.button{display:inline-block;vertical-align:middle;margin:0 0 1rem 0;padding:.85em 1em;border:1px solid transparent;border-radius:.25rem;transition:background-color .25s ease-out,color .25s ease-out;font-size:.75rem;-webkit-appearance:none;line-height:1;text-align:center;cursor:pointer;}
[data-whatinput=mouse] .button{outline:0;}
h3,h5,h6{font-family:Montserrat,sans-serif;font-weight:600;}
h3{letter-spacing:-.03125rem;}
h5{letter-spacing:-.03125rem;}
.button{font-size:.75rem;line-height:1rem;padding:.6875rem 1.5rem;border-radius:1.25rem;letter-spacing:1px;text-align:center;font-weight:600;text-transform:uppercase;min-width:9.75rem;}
@media print,screen and (max-width:47.99875em){
.button{min-width:0;}
}
.button-stretch-medium{max-width:18.9375rem;width:100%;}
.intro{letter-spacing:-.03125rem;font-weight:600;font-family:Montserrat,sans-serif;}
.color-green{color:#5456ff;}
.color-grey-4{color:#787d78;}
.f-w-400{font-weight:400;}
.f-w-600{font-weight:600;}
.p-b-5{padding-bottom:.3125rem;}
.m-b-20{margin-bottom:1.25rem;}
.m-b-25{margin-bottom:1.5625rem;}
.m-b-0{margin-bottom:0!important;}
button:focus{outline:0;}
/*! CSS Used from: https://static.olark.com/jsclient/styles/cryptic-capybara/theme.css */
::-webkit-input-placeholder,:-moz-placeholder,::-moz-placeholder,:-ms-input-placeholder{font-family:helvetica,arial,sans-serif;}


@media all{
h5,h6{overflow-wrap:break-word;}
ul{overflow-wrap:break-word;}
p{overflow-wrap:break-word;}
}
a{background-color:transparent;}
*,::after,::before{box-sizing:inherit;}
.row{max-width:81.75rem;margin-right:auto;margin-left:auto;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;}
.row .row{margin-right:-.75rem;margin-left:-.75rem;}
@media print,screen and (min-width:48em){
.row .row{margin-right:-.75rem;margin-left:-.75rem;}
}
@media print,screen and (min-width:64em){
.row .row{margin-right:-.75rem;margin-left:-.75rem;}
}
.row:not(.expanded) .row{max-width:none;}
.columns{-webkit-flex:1 1 0px;-ms-flex:1 1 0px;flex:1 1 0px;padding-right:.75rem;padding-left:.75rem;min-width:0;}
@media print,screen and (min-width:48em){
.columns{padding-right:.75rem;padding-left:.75rem;}
}
.small-12{-webkit-flex:0 0 100%;-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%;}
::-webkit-input-placeholder{color:rgba(30,70,70,.5);}
:-ms-input-placeholder{color:rgba(30,70,70,.5);}
::placeholder{color:rgba(30,70,70,.5);}
// div,h5,h6,li,p,ul{margin:0;padding:0;}
p{margin-bottom:1.5em;font-size:inherit;line-height:1.5;text-rendering:optimizeLegibility;}
h5,h6{font-family:"DM Serif Display",serif;font-style:normal;font-weight:400;color:inherit;text-rendering:optimizeLegibility;}
h5{font-size:1rem;line-height:1.5;margin-top:0;margin-bottom:.875rem;}
h6{font-size:1rem;line-height:1.5;margin-top:0;margin-bottom:.875rem;}
@media print,screen and (min-width:48em){
h5{font-size:1.25rem;line-height:1.6;}
h6{font-size:1rem;line-height:1.5;}
}
a{line-height:inherit;color:#3282a0;text-decoration:none;cursor:pointer;}
a:focus,a:hover{color:#2b708a;}
ul{margin-bottom:1.5em;list-style-position:outside;line-height:1.5;}
li{font-size:inherit;}
ul{margin-left:1.25rem;list-style-type:disc;}
@media print{
*{background:0 0!important;color:#000!important;color-adjust:economy;box-shadow:none!important;text-shadow:none!important;}
a,a:visited{text-decoration:underline;}
a[href]:after{content:" (" attr(href) ")";}
a[href^='javascript:']:after{content:'';}
p{orphans:3;widows:3;}
}
.button{display:inline-block;vertical-align:middle;margin:0 0 1rem 0;padding:.85em 1em;border:1px solid transparent;border-radius:.25rem;transition:background-color .25s ease-out,color .25s ease-out;font-size:.75rem;-webkit-appearance:none;line-height:1;text-align:center;cursor:pointer;}
[data-whatinput=mouse] .button{outline:0;}
.button{background-color:#5456ff;color:#fff;}
.button:focus,.button:hover{background-color:#7cb73b;color:#1e4646;}
.button.hollow,.button.hollow:focus,.button.hollow:hover{background-color:transparent;}
.button.hollow{border:1px solid #91c855;color:#91c855;}
a.button:focus,a.button:hover{text-decoration:none;}
.accordion{margin-left:0;background:#053a7a;list-style-type:none;}
.accordion-item:first-child>:first-child{border-radius:.25rem .25rem 0 0;}
.accordion-item:last-child>:last-child{border-radius:0 0 .25rem .25rem;}
.accordion-title{position:relative;display:block;padding:1rem 1.875rem 1rem 1.5rem;border:0;border-bottom:0;font-size:1rem;line-height:1;color:#fff;}
:last-child:not(.is-active)>.accordion-title{border-bottom:0;border-radius:0 0 .25rem .25rem;}
.accordion-title:focus,.accordion-title:hover{background-color:#053a7a;}
.accordion-title::before{position:absolute;top:50%;right:1rem;margin-top:-.5rem;content:"";}
.accordion-content{display:none;padding:0 1.5rem 1rem;border:0;border-bottom:0;background-color:#053a7a;color:#c1c4c2;}
:last-child>.accordion-content:last-child{border-bottom:0;}
p{letter-spacing:-.00625rem;}
h5,h6{font-family:Montserrat,sans-serif;font-weight:600;}
h5{letter-spacing:-.03125rem;}
.button{font-size:.75rem;line-height:1rem;padding:.6875rem 1.5rem;border-radius:1.25rem;letter-spacing:1px;text-align:center;font-weight:600;text-transform:uppercase;min-width:9.75rem;}
@media print,screen and (max-width:47.99875em){
.button{min-width:0;}
}
.button-thin{font-size:.625rem;line-height:1rem;padding:.25rem 1rem;}
.button.hollow{border:1px solid #91c855;color:#1e4646;}
.bg-grey-5 .button.hollow{color:#fff;}
.button.hollow.border-grey-4{border-color:#787d78;}
.intro{letter-spacing:-.03125rem;font-weight:600;font-family:Montserrat,sans-serif;}
.intro p{line-height:inherit;font-weight:inherit;}
.color-white{color:#fff;}
.bg-grey-5{background-color:#053a7a;}
.f-w-400{font-weight:400;}
.full-height{height:100%;}
.border-radius-8{border-radius:.5rem;}
.m-b-16{margin-bottom:1rem;}
.m-t-40{margin-top:2.5rem;}
.m-b-0{margin-bottom:0!important;}
.text-16-24{font-size:1rem;line-height:1.5rem;}
.entry-content p{word-break:break-word;}
.accordion{margin-bottom:0;}
.accordion-item{border-bottom:1px solid #787d78;border-radius:0!important;}
.accordion-item:first-child{border-top:1px solid #787d78;}
.accordion-title:focus{color:#fff;}
.accordion-title:hover{color:#a0e6f5;text-decoration:underline;}
.accordion-title:before{background-image:url(../assets/imgs/accordion-arrow-down.svg);background-size:contain;width:.9375rem;height:.5625rem;right:.53125rem;margin-top:-.1875rem;transition:-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out;transition:transform .2s ease-in-out,-webkit-transform .2s ease-in-out;}
.is-active .accordion-title:before{background-image:url(../assets/imgs/accordion-arrow-down-white.svg); transform: rotate(-180deg);}
.accordion-content{font-size:.875rem;}
.accordion-content .intro{font-weight:inherit;}
.accordion-content p{
  list-style-position: outside;
  list-style-type: none;
  color: #c1c4c2;
  font-family: Montserrat,sans-serif;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0;
  font-size: 1rem;
  text-rendering: optimizeLegibility;
  letter-spacing: -.00625rem;
  line-height: inherit;
  font-weight: inherit;
  word-break: break-word;
  margin-bottom: 0;
}
.row .row,.vc_row .row{margin-left:-.75rem;margin-right:-.75rem;}
@media print,screen and (min-width:48em){
.row .row,.vc_row .row{margin-left:-.75rem;margin-right:-.75rem;}
}
[data-whatinput=mouse] a:focus{outline:0;}
.faq-widget-wrapper{margin-bottom:2.5rem;}
.faq-widget-wrapper.inset{padding:2.5rem 1.5rem;}
// @media print,screen and (min-width:64em){
.faq-sticky .faq-widget-wrapper{position:-webkit-sticky;position:sticky;top:4rem;}
// }
.faq-widget-wrapper .accordion-content,.faq-widget-wrapper .accordion-title{padding-left:0;padding-right:1.875rem;}
#application-form .faq-widget-wrapper .button{display:none;}
/*! CSS Used from: https://static.olark.com/jsclient/styles/cryptic-capybara/theme.css */
::-webkit-input-placeholder,:-moz-placeholder,::-moz-placeholder,:-ms-input-placeholder{font-family:helvetica,arial,sans-serif;}

@media all{
p{overflow-wrap:break-word;}
}
a{background-color:transparent;}
*,::after,::before{box-sizing:inherit;}
::-webkit-input-placeholder{color:rgba(30,70,70,.5);}
:-ms-input-placeholder{color:rgba(30,70,70,.5);}
::placeholder{color:rgba(30,70,70,.5);}
// div,p{margin:0;padding:0;}
p{margin-bottom:1.5em;font-size:inherit;line-height:1.5;text-rendering:optimizeLegibility;}
a{line-height:inherit;color:#3282a0;text-decoration:none;cursor:pointer;}
a:focus,a:hover{color:#2b708a;}
.text-center{text-align:center;}
@media print{
*{background:0 0!important;color:#000!important;color-adjust:economy;box-shadow:none!important;text-shadow:none!important;}
a,a:visited{text-decoration:underline;}
a[href]:after{content:" (" attr(href) ")";}
a[href^='javascript:']:after{content:'';}
p{orphans:3;widows:3;}
}
@media print,screen and (min-width:64em){
.hide-for-large{display:none!important;}
}
@media screen and (max-width:63.99875em){
.show-for-large{display:none!important;}
}
.align-justify{-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}
.align-middle{-webkit-align-items:center;-ms-flex-align:center;align-items:center;}
.flex-container{display:-webkit-flex;display:-ms-flexbox;display:flex;}
p{letter-spacing:-.00625rem;}
.f-w-600{font-weight:600;}
.uppercase{text-transform:uppercase;}
.pos-rel{position:relative;}
.m-b-30{margin-bottom:1.875rem;}
.ls-1{letter-spacing:.0625rem;}
.entry-content p{word-break:break-word;}
[data-whatinput=mouse] a:focus{outline:0;}
.plan-card{color:#c1c4c2;background-color:#053a7a;padding:3.25rem 2.5rem;font-size:.75rem;line-height:1rem;font-weight:500;border-radius:.5rem;}
@media print,screen and (min-width:64em){
.plan-card{position:-webkit-sticky;position:sticky;top:4rem;}
}
@media print,screen and (max-width:63.99875em){
.plan-card{padding:1.625rem 1.25rem;border-radius:0;margin-left:-.75rem;margin-right:-.75rem;}
}
.plan-card .card-title{color:#fff0a5;margin-bottom:2.5rem;font-weight:600;}
@media print,screen and (max-width:63.99875em){
.plan-card .card-title{margin-bottom:0;text-align:left;margin-left:1.875rem;}
}
@media print,screen and (max-width:63.99875em){
.plan-card .card-content{display:none;}
}
.plan-card .plan-item{border-bottom:1px solid rgba(255,255,255,.25);padding-top:.375rem;padding-bottom:.375rem;}
@media print,screen and (max-width:63.99875em){
.plan-card .plan-item--amount{margin-left:1.875rem;border-bottom:0;}
}
.plan-card .plan-item--amount .item-value{font-size:2rem;line-height:2.5rem;}
@media print,screen and (max-width:63.99875em){
.plan-card .plan-item--amount .item-value{font-size:1.625rem;line-height:2rem;}
}
.plan-card p{margin-bottom:0;}
.plan-card .item-value{color:#fff;font-size:1.25rem;line-height:2rem;letter-spacing:-.03125rem;text-align:right;}
.plan-card .plan-item--amount--value{font-size:1.625rem;}
.toggle-plan-card{position:absolute;top:.625rem;}
.toggle-plan-card svg{transition:-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out;transition:transform .2s ease-in-out,-webkit-transform .2s ease-in-out;}
/*! CSS Used from: https://static.olark.com/jsclient/styles/cryptic-capybara/theme.css */
::-webkit-input-placeholder,:-moz-placeholder,::-moz-placeholder,:-ms-input-placeholder{font-family:helvetica,arial,sans-serif;}

@media all{
h4{overflow-wrap:break-word;}
p{overflow-wrap:break-word;}
}
@media print,screen and (min-width:48em){
.reveal{right:auto;left:auto;margin:0 auto;}
}
button,input{font-size:100%;line-height:1.15;margin:0;}
button,input{overflow:visible;}
button{text-transform:none;}
[type=button],button{-webkit-appearance:button;}
[type=button]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0;}
[type=button]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText;}
*,::after,::before{box-sizing:inherit;}
button{padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border-radius:.25rem;background:0 0;line-height:1;cursor:auto;}
[data-whatinput=mouse] button{outline:0;}
[type=email],[type=tel],[type=text]{display:block;box-sizing:border-box;width:100%;height:3.4375rem;margin:0 0 1rem;padding:1rem;border:0;border-radius:.25rem;background-color:#f0f4f0;box-shadow:none;font-size:1rem;font-weight:600;line-height:1.5;color:#1e4646;transition:box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;}
[type=email]:focus,[type=tel]:focus,[type=text]:focus{outline:0;border:0;background-color:#f0f4f0;box-shadow:none;transition:box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;}
input:disabled{background-color:#f0f4f0;cursor:not-allowed;}
[type=button]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.25rem;}
::-webkit-input-placeholder{color:rgba(30,70,70,.5);}
:-ms-input-placeholder{color:rgba(30,70,70,.5);}
::placeholder{color:rgba(30,70,70,.5);}
.is-invalid-label{color:#d44e4e;}
// div,h4,p{margin:0;padding:0;}
p{margin-bottom:1.5em;font-size:inherit;line-height:1.5;text-rendering:optimizeLegibility;}
h4{font-family:"DM Serif Display",serif;font-style:normal;font-weight:400;color:inherit;text-rendering:optimizeLegibility;}
h4{font-size:1.375rem;line-height:1.45455;margin-top:0;margin-bottom:.875rem;}
@media print,screen and (min-width:48em){
h4{font-size:1.5rem;line-height:1.33333;}
}
@media print{
*{background:0 0!important;color:#000!important;color-adjust:economy;box-shadow:none!important;text-shadow:none!important;}
p{orphans:3;widows:3;}
}
.button{display:inline-block;vertical-align:middle;margin:0 0 1rem 0;padding:.85em 1em;border:1px solid transparent;border-radius:.25rem;transition:background-color .25s ease-out,color .25s ease-out;font-size:.75rem;-webkit-appearance:none;line-height:1;text-align:center;cursor:pointer;}
[data-whatinput=mouse] .button{outline:0;}
.button,.button[disabled],.button[disabled]:focus,.button[disabled]:hover{background-color:#5456ff;color:#fff;}
.button:focus,.button:hover{background-color:#053a7a;color:#fff;}
.button.hollow,.button.hollow:focus,.button.hollow:hover{background-color:transparent;}
.button.hollow{border:1px solid #91c855;color:#91c855;}
.button.hollow:focus,.button.hollow:hover{border-color:#5456ff;color:#5456ff;}
.button[disabled]{opacity:.25;cursor:not-allowed;}
.close-button{position:absolute;z-index:10;color:#413e37;cursor:pointer;}
[data-whatinput=mouse] .close-button{outline:0;}
.close-button:focus,.close-button:hover{color:#000;}
.close-button{right:1rem;top:.5rem;font-size:2em;line-height:1;}
.reveal-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1005;display:none;background-color:rgba(0,0,0,.45);overflow-y:auto;}
.reveal{z-index:1006;-webkit-backface-visibility:hidden;backface-visibility:hidden;display:none;padding:2.5rem 2rem 1.5rem;border:1px solid #787d78;border-radius:.25rem;background-color:#fff;position:relative;top:100px;margin-right:auto;margin-left:auto;overflow-y:auto;}
[data-whatinput=mouse] .reveal{outline:0;}
@media print,screen and (min-width:48em){
.reveal{min-height:0;}
}
.reveal>:last-child{margin-bottom:0;}
@media print,screen and (min-width:48em){
.reveal{width:600px;max-width:81.75rem;}
}
@media print,screen and (max-width:47.99875em){
.reveal{top:0;right:0;bottom:0;left:0;width:100%;max-width:none;height:100%;min-height:100%;margin-left:0;border:0;border-radius:0;}
}
.align-middle{-webkit-align-items:center;-ms-flex-align:center;align-items:center;}
.flex-container{display:-webkit-flex;display:-ms-flexbox;display:flex;}
p{letter-spacing:-.00625rem;}
h4{font-family:Montserrat,sans-serif;font-weight:600;}
h4{letter-spacing:-.0375rem;}
.button{font-size:.75rem;line-height:1rem;padding:.6875rem 1.5rem;border-radius:1.25rem;letter-spacing:1px;text-align:center;font-weight:600;text-transform:uppercase;min-width:9.75rem;}
@media print,screen and (max-width:47.99875em){
.button{min-width:0;}
}
.button-thin{font-size:.625rem;line-height:1rem;padding:.25rem 1rem;}
.button.hollow{border:1px solid #00234d;color:#053a7a;}
.color-grey-4{color:#787d78;}
.f-w-500{font-weight:500;}
.h-auto{height:auto;}
.mh-auto{min-height:auto;}
.p-l-16{padding-left:1rem;}
.p-r-25{padding-right:1.5625rem;}
.p-l-25{padding-left:1.5625rem;}
.m-b-10{margin-bottom:.625rem;}
.m-b-18{margin-bottom:1.125rem;}
.m-b-20{margin-bottom:1.25rem;}
.m-b-32{margin-bottom:2rem;}
.m-b-40{margin-bottom:2.5rem;}
@media print,screen and (max-width:47.99875em){
.m-b-40{margin-bottom:2rem;}
}
.adjust-spacer{margin-left:-.25rem;margin-right:-.25rem;}
.half-spacer{padding-left:.25rem;padding-right:.25rem;}
.text-12-16{font-size:.75rem;line-height:1rem;}
@media print,screen and (max-width:47.99875em){
.flex-container--sm-full{display:block;}
.sp-l-0{padding-left:0;}
.sp-r-0{padding-right:0;}
}
[type=email],[type=tel],[type=text]{padding:1rem;font-size:1rem;line-height:1.5rem;color:#053a7a;width:100%;margin-bottom:.5rem;}
[type=email]:focus,[type=tel]:focus,[type=text]:focus{box-shadow:0 0 0 1px #787d78;}
.placeholder-animate [type=email]::-webkit-input-placeholder,.placeholder-animate [type=tel]::-webkit-input-placeholder,.placeholder-animate [type=text]::-webkit-input-placeholder{color:transparent;}
.placeholder-animate [type=email]:-moz-placeholder,.placeholder-animate [type=tel]:-moz-placeholder,.placeholder-animate [type=text]:-moz-placeholder{color:transparent;}
.placeholder-animate [type=email]::-moz-placeholder,.placeholder-animate [type=tel]::-moz-placeholder,.placeholder-animate [type=text]::-moz-placeholder{color:transparent;}
.placeholder-animate [type=email]:-ms-input-placeholder,.placeholder-animate [type=tel]:-ms-input-placeholder,.placeholder-animate [type=text]:-ms-input-placeholder{color:transparent;}
.placeholder-animate [type=email]:focus,.placeholder-animate [type=tel]:focus,.placeholder-animate [type=text]:focus{padding:1.625rem 1rem .875rem;}
.placeholder-animate [type=email]:focus::-webkit-input-placeholder,.placeholder-animate [type=tel]:focus::-webkit-input-placeholder,.placeholder-animate [type=text]:focus::-webkit-input-placeholder{font-size:.75rem;line-height:1rem;}
.placeholder-animate [type=email]:focus:-moz-placeholder,.placeholder-animate [type=tel]:focus:-moz-placeholder,.placeholder-animate [type=text]:focus:-moz-placeholder{font-size:.75rem;line-height:1rem;}
.placeholder-animate [type=email]:focus::-moz-placeholder,.placeholder-animate [type=tel]:focus::-moz-placeholder,.placeholder-animate [type=text]:focus::-moz-placeholder{font-size:.75rem;line-height:1rem;}
.placeholder-animate [type=email]:focus:-ms-input-placeholder,.placeholder-animate [type=tel]:focus:-ms-input-placeholder,.placeholder-animate [type=text]:focus:-ms-input-placeholder{font-size:.75rem;line-height:1rem;}
.form-item{width:100%;position:relative;}
.placeholder-animate input:not(:placeholder-shown){padding:1.625rem 1rem .875rem;font-size:.75rem;line-height:1rem;}
input:focus~span.placeholder,input:not(:placeholder-shown)~span.placeholder{top:.75rem;font-size:.625rem;line-height:.75rem;}
input:focus~span.placeholder{color:#50aad2;}
span.placeholder{position:absolute;top:1rem;left:1.25rem;font-size:1rem;line-height:1.5;font-weight:600;color:rgba(30,70,70,.5);transition:all .3s;pointer-events:none;}
button:focus{outline:0;}
#application-form #downpayment-amount~.placeholder{left:1rem;}
#email-quote-modal .placeholder{font-size:.75rem;line-height:1rem;top:1.3125rem;}
#email-quote-modal input:focus~span.placeholder,#email-quote-modal input:not(:placeholder-shown)~span.placeholder{top:.625rem;}
/*! CSS Used from: https://static.olark.com/jsclient/styles/cryptic-capybara/theme.css */
::-webkit-input-placeholder,:-moz-placeholder,::-moz-placeholder,:-ms-input-placeholder{font-family:helvetica,arial,sans-serif;}

.get-quote {
  margin-bottom: 2.5rem;
}
.register-form {
  h3 {
    color: #053A7A;
    overflow-wrap: break-word;
    margin: 0;
    padding: 0;
    font-style: normal;
    text-rendering: optimizeLegibility;
    margin-top: 0;
    margin-bottom: .875rem;
    font-size: 2rem;
    line-height: 1.25;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    letter-spacing: -.03125rem;
  }
  .signup-button {
    overflow: visible;
    background: 0 0;
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 1rem 0;
    border: 1px solid transparent;
    transition: background-color .25s ease-out,color .25s ease-out;
    -webkit-appearance: none;
    font-size: .75rem;
    line-height: 1rem;
    padding: .6875rem 1.5rem;
    border-radius: 1.25rem;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    min-width: 9.75rem;
    width: 100%;
    outline: 0;
    background-color: #5456ff;
    color: #fff;
  }
  .signup-button[disabled] {
    opacity: .25;
    cursor: not-allowed;
  }
  a {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    -webkit-font-smoothing: antialiased;
    text-align: center;
    box-sizing: inherit;
    background-color: transparent;
    color: #3282a0;
    cursor: pointer;
    font-size: .75rem;
    line-height: 1rem;
    font-weight: 500;
    text-decoration: underline;
  }
}
.right-panel {
  background-image: url(../assets/imgs/American_Credit_Business_Loans.png);
  background-position: center;
  background-size: cover;
}
 @media print, screen and (min-width: 64em) {
    .minimal-title {
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      padding-bottom: 30px;
    }
  }
  .intro {
    font-size: 100%;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    color: #787d78;
    font-weight: 400;
    // margin-bottom: 1.25rem;
  }
  .ls-1 {
    letter-spacing: .0625rem;
  }
  .text-12-16 {
      font-size: .75rem;
      line-height: 1rem;
  }
  .f-w-600 {
      font-weight: 600;
  }
  .uppercase {
      text-transform: uppercase;
  }
  .color-gray-5, .color-grey-5 {
      color: #053A7A;
  }
  .text-center {
      text-align: center;
  }
  .amcredit-font {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      /* font-weight: 400; */
      line-height: 1.5;
      color: #053A7A;
  }
</style>

<style lang="scss">
  .vue-form-generator .input-top-placeholder .form-control{
    padding: 26px 16px 14px 12px;
  }
  input:not(:placeholder-shown)~span.placeholder {
      top: 9px;
      font-size: 10px;
      line-height: 12px;
  }
  .placeholder {
    position: absolute;
    top: 16px;
    left: 13px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: rgba(30,70,70,.5);
    transition: all .3s;
    pointer-events: none;
  }
  input:focus ~ .placeholder{
    left: 13px;
    color: #50aad2;
    top: 9px;
    font-size: 10px;
    line-height: 12px;
    font-weight: 600;
  }

  .form-control::-webkit-input-placeholder {
    /* WebKit browsers */
    color: transparent !important;
  }
  .m-b-20 {
    margin-bottom: 1.25rem !important;
  }
  .m-b-40 {
    margin-bottom: 2.5rem !important;
  }
  .custom-input {
    .hint {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      line-height: 1.5;
      -webkit-font-smoothing: antialiased;
      box-sizing: inherit;
      margin: 0;
      padding: 0;
      font-size: .625rem !important;
      font-style: normal;
      color: #787d78;
      margin-top: -.3125rem;
      font-weight: 600;
      padding-left: 1rem;
    }
  }
  .wizard-progress-with-circle {
    display: none;
  }
  .get-quote {
    .wizard-nav.wizard-nav-pills {
      display: none;
    }
    .wizard-footer-right {
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// GetQuoteAndSignup.vue?56bbbb9f